import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  checkIcon: {
    height: Theme.px(54),
    width: Theme.px(54),
  },
  settingsClosedCaptioningTopContent: {
    paddingBottom: Theme.px(59),
  },
  settingsClosedCaptioningWrapper: {
    alignItems: 'flex-start',
    paddingTop: Theme.px(311),
  },
});
